import { render, staticRenderFns } from "./OnboardingContact.vue?vue&type=template&id=c517c60a&scoped=true&"
import script from "./OnboardingContact.vue?vue&type=script&lang=js&"
export * from "./OnboardingContact.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingContact.vue?vue&type=style&index=0&id=c517c60a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c517c60a",
  null
  
)

export default component.exports